import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import Gicon from "../icon/googleicon";
import AccountTypeModal from "../AccountTypeModal";
import { persistForumUser, resolveGoogleLogin } from "../../utils/googleAuth";

const MyGoogleLogin = ({ onLogin }) => {
  const [pendingGoogle, setPendingGoogle] = useState(null);
  const [accountTypeLoading, setAccountTypeLoading] = useState(false);

  const finishWithUser = (user) => {
    persistForumUser(user);
    if (onLogin) onLogin(user);
    window.location.href = "/";
  };

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const userInfoRes = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        const userInfo = await userInfoRes.json();
        const googleProfile = {
          access_token: tokenResponse.access_token,
          google_id: userInfo.sub,
          email: userInfo.email,
          name: userInfo.name || "",
          avatar: userInfo.picture || "",
        };

        const result = await resolveGoogleLogin(googleProfile);

        if (result.needsAccountType) {
          setPendingGoogle(result.pending);
          return;
        }

        if (result.user) {
          finishWithUser(result.user);
        } else {
          alert(result.error || "Google login failed");
        }
      } catch (err) {
        console.error("Google login failed:", err);
      }
    },
    onError: () => console.log("Google login failed"),
  });

  const handleAccountTypeConfirm = async ({ typeofuser, password, country, position }) => {
    if (!pendingGoogle) return;
    setAccountTypeLoading(true);
    try {
      const result = await resolveGoogleLogin(pendingGoogle, {
        typeofuser,
        password,
        country,
        position,
      });
      if (result.user) {
        setPendingGoogle(null);
        finishWithUser(result.user);
      } else {
        alert(result.error || "Could not create your account.");
      }
    } catch (err) {
      console.error("Google signup failed:", err);
      alert("Could not create your account.");
    } finally {
      setAccountTypeLoading(false);
    }
  };

  return (
    <>
      <AccountTypeModal
        open={!!pendingGoogle}
        email={pendingGoogle?.email}
        loading={accountTypeLoading}
        onConfirm={handleAccountTypeConfirm}
        onCancel={() => setPendingGoogle(null)}
      />
      <button
        onClick={() => login()}
        style={{
          backgroundColor: "transparent",
          color: "#0077b6",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Gicon /> Sign in with Google
      </button>
    </>
  );
};

export default MyGoogleLogin;
